import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Lady = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 20 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
          <path
            stroke={props.color || theme.palette.grey600}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M7 17c-1.562.55-3 1.024-3 2.291V22m8.286-.775V19H7.78l-.28 2.225M16 22v-2.587c0-1.17-1.423-1.905-3-2.413"
          />
          <path
            stroke={props.color || theme.palette.grey600}
            strokeWidth="1.5"
            d="M18.685 15.896c-1.005-.723-1.605-1.873-1.605-3.077V7.264C17.08 3.26 13.68 0 9.5 0S1.92 3.259 1.92 7.264v5.555c0 1.204-.6 2.354-1.606 3.077L0 16.122l.195.327c.017.029.259.105 1.023.831l2.931.24v.116l2.46-.964c.67-.263 1.107-.888 1.107-1.582v-.534C5.53 13.196 4.15 10.85 4.15 8.27c0-.842.598-1.575 1.45-1.78l3.036-.727a4.142 4.142 0 011.73 0l3.036.727c.852.205 1.45.938 1.45 1.78 0 2.581-1.382 4.928-3.568 6.287v.534c0 .694.438 1.32 1.108 1.582l2.46.964v-.117l2.229-.427s1.708-.616 1.725-.643l.195-.327-.315-.226z"
          />
          <circle
            cx="7.5"
            cy="8.5"
            r="1"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
          />
          <circle
            cx="11.5"
            cy="8.5"
            r="1"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
          />
          <path
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            d="M11 11h-.75c0 .552-.336 1-.75 1s-.75-.448-.75-1H8c0 1.103.673 2 1.5 2s1.5-.897 1.5-2z"
          />
          <path
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            d="M18 16.944l-.17-.168-2.565.504-2.164-.87a1.326 1.326 0 01-.842-1.232v-.319c2.223-1.51 3.614-4.012 3.614-6.767 0-1.08-.744-2.017-1.81-2.279l-3.077-.755c-.314-.077-1.657-.077-1.972 0l-3.076.756a2.353 2.353 0 00-1.811 2.278c0 2.755 1.39 5.258 3.614 6.768v.319c0 .543-.33 1.026-.842 1.232l-2.164.87-2.564-.505-.17.168c-.06.059 16.059.059 15.999 0zM7.78 16.22c.256-.24.416-.523.459-.827.438.153.9.285 1.38.392l.161.036.16-.035c.481-.108.942-.24 1.38-.393.044.304.203.587.46.827.083.412-.07.67-.46.777-.245.067-1.272.067-3.081 0l-.46-.777zM5.03 8.092c0-.671.464-1.254 1.127-1.417l3.076-.756c.301-.073.563-.227.767-.434.204.207.466.36.767.434l3.076.756a1.464 1.464 0 011.127 1.417c0 3.118-1.99 5.88-4.97 6.921-2.979-1.04-4.97-3.803-4.97-6.92z"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 20 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M10.001 12.001c1.223 0 2.36-.369 3.31-1h4.69l-1.685-6.176A6.536 6.536 0 0 0 10.899.076a6.044 6.044 0 0 0-.898-.075c-.306 0-.604.03-.898.075a6.536 6.536 0 0 0-5.417 4.749l-1.685 6.176h4.69c.95.631 2.087 1 3.31 1zm-10 8.487v3.513h3v-8.138c-1.849 1.178-3 2.815-3 4.625zm17-4.625v8.138h3v-3.513c0-1.81-1.151-3.447-3-4.625zm-12-.984v5.122h10v-5.122c-1.473-.555-3.178-.878-5-.878s-3.528.323-5 .878zm2 2.122a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
